<template>
  <div v-if="policies.data.length" class="rounded border bg-white info-panel custom-table">
    <div class="table-responsive">
      <table
          class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800"
          style="white-space: nowrap!important;">
        <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-95px">ID</th>
            <th>Номер договора</th>
            <th>Страхователь</th>
            
            <th class="w-95px">Продукт</th>
            <th>Премия</th>
            <th>Создал</th>
            <th>Статус</th>
            <th>Срок действия</th>
            <th>Дата создания</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in policies.data" class="align-middle" :class="disabledKey === key ? 'opacity-25' : ''">
            <td class="text-center" v-html="item.id"></td>
            <td v-html="item.global_id"></td>
            <td>{{ item.insurer_title }}</td>
            <td><span :title="item.product">{{item.product_type}}</span></td>
            <td>{{ item.premium.toLocaleString('ru-RU') }} тг.</td>
            <td v-html="item.username"></td>
            <td>
              <span class="px-3 py-1 rounded text-white fs-9 fw-bold" v-html="item.statusName" :class="getStyle(item.status)"></span>
            </td>
            <td>
              <span class="badge badge-light-primary">{{ item.from }}</span> -
              <span class="badge badge-light-danger">{{ item.to }}</span>
            </td>
            <td v-html="item.created_at"></td>
            <td class="text-end">
              <i v-if="item.status === 0 && item.payment_type === 1 && today === item.created_at.slice(0,10)"
                 class="ki-outline ki-arrows-circle text-warning fs-4 cursor-pointer me-2"
                 @click="updatePolicy(key, item.id)"
              ></i>
              <i class="ki-outline ki-right-square text-primary fs-4 cursor-pointer" @click="getItemPolicy(key)"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <bootstrap5-pagination class="pagination-outline pt-3 mb-3 border-top" v-if="policies" :limit="5" :data="policies" @pagination-change-page="getPolicies"/>
    </div>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center rounded border bg-white info-panel fs-6 text-gray-400 custom-table h-200px">
    Нет информации
  </div>
</template>
<script>
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import axios                  from 'axios'

export default {
  name: 'PoliciesLocal',
  components: {
    Bootstrap5Pagination
  },
  props: {
    policies: null
  },
  computed: {
    today() {
      {
        const d    = new Date()
        let month  = '' + (d.getMonth() + 1)
        let day    = '' + d.getDate()
        const year = d.getFullYear()

        if (month.length < 2) month = '0' + month;
        if (day.length < 2)   day   = '0' + day;

        return [day, month, year].join('.');
      }
    }
  },
  data() {
    return {
      dataKey: 0,
      operatorErrorModalData: {
        resident: null,
        global:   null,
        person:   null,
        hash:     null,
        id:       null
      },
      disabledUpdate: false,
      disabledKey: null
    }
  },
  methods: {
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3) return 'bg-warning'
    },
    getPolicies(val) {
      this.$emit('reloaded', val)
    },
    getItemPolicy(key) {
      if (!this.disabledUpdate) this.$emit('open', this.policies.data[key])
    },
    updatePolicy(key, id) {
      if (!this.disabledUpdate) {
        this.disabledUpdate = true
        this.disabledKey = key
        axios.post('/api/policy/item', {id:id})
            .then(res => {
              if (res.data.hasOwnProperty('id')) {
                this.policies.data[key] = res.data
              }
            })
            .catch(err => {console.log(err.message)})
            .finally(() => {
              this.disabledUpdate = false
              this.disabledKey    = null
            })
      }
    }
  }
}
</script>

<style></style>